





































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({})
export default class NumberInfo extends Vue {

    @Prop({type: String, default: null})
    private title!: string;

    @Prop({type: String, default: null})
    private subTitle!: string;

    @Prop({type: String, default: ''})
    private total!: string;

    @Prop({type: Number, default: 0})
    private subTotal!: number;

    @Prop({type: String, default: null})
    private status!: string;

    @Prop({type: String, default: null})
    private suffix!: string;

    @Prop({type: Number, default: null})
    private gap!: number;
}
